import type { BlogPost } from './blog-types';

export type BlogSummary = Omit<BlogPost, 'content' | 'headings'>;

export function filterArticles(articles: BlogSummary[], query: string, category = 'all') {
  const search = query.trim().toLowerCase();
  return articles.filter(
    article =>
      (category === 'all' || article.category === category) &&
      `${article.title} ${article.excerpt}`.toLowerCase().includes(search)
  );
}

export function categoryLabel(category: string) {
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
